import React from "react";
import { Button } from "react-bootstrap";

export const Header = () => {
  return (
    <div className="formeditor-header bg-white rounded-top d-flex justify-content-between align-items-center shadow-sm relative">
      <Button variant="editorclose border-0 bg-transparent border">
        <i className="bx bx-x bx-md"></i>
      </Button>
      <div className="headereditor-title border-start py-3 ps-3">
        <h3>Cybersecurity Admission Form</h3>
        <div className="headereditor-sub-title d-flex align-items-center">
          <i className="bx bx-folder bx-xs me-1"></i> Admission Form{" "}
        </div>
      </div>
      <div className="editor-tab p-1 rounded-2 d-flex gap-2 align-items-center mx-auto">
        <Button variant="editor btn-sm active">Fields</Button>
        <Button variant="editor btn-sm">Responses</Button>
        <Button variant="editor btn-sm">Form Setting</Button>
      </div>
      <div className="d-flex align-items-center">
        <div className="unduredo-btns d-flex align-items-center py-3">
          <Button variant="action btn-sm px-1">
            <i className="bx bx-undo bx-sm"></i>
          </Button>
          <Button variant="action btn-sm px-1">
            <i className="bx bx-redo bx-sm"></i>
          </Button>
        </div>
        <div className="editor-action-btns ms-2 d-flex gap-2 align-items-center py-3 px-3">
          <Button variant="gray-light btn-sm bx-sm view-btn">
            <i className="bx bx-show-alt"></i>
          </Button>
          <Button variant="gray-light btn-sm">Save</Button>
          <Button variant="primary btn-sm">Publish</Button>
        </div>
      </div>
    </div>
  );
};
